module.exports = __webpack_public_path__ + "05_long_black.83d63f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_long_black.png
// module id = 4TOq
// module chunks = 0